import { createContext, useContext } from "react";

export const AuthContext = createContext();

const GTOKEN_KEY = "GLogin_admin_Token";
// const GEXPIRY_KEY = "googlesession-expiry";
// const GONE_DAY_MS = 24 * 60 * 60 * 1000;
const LOGIN_KEY = "Login_amdin_Token";

export const AuthProvider = ({ children }) => {
  // Store token + set expiry time (1 day from now)

  const storeGooleAuthToken = (googleToken) => {
    // const expiryTime = Date.now()+GONE_DAY_MS;
    localStorage.setItem(GTOKEN_KEY, googleToken);
    // localStorage.setItem(GEXPIRY_KEY, expiryTime.toString())
  };

  const storeAdminAuthToken = (loginToken) => {
    // const expiryTime = Date.now()+GONE_DAY_MS;
    localStorage.setItem(LOGIN_KEY, loginToken);
    // localStorage.setItem(GEXPIRY_KEY, expiryTime.toString())
  };

  const getGoogleAuthToken = () => {
    const token = localStorage.getItem(GTOKEN_KEY);
    // const expiry = parseInt(localStorage.getItem(GEXPIRY_KEY) || "0", 10);

    if (!token) {
      // Expired or missing → clear storage
      localStorage.removeItem(GTOKEN_KEY);
      // localStorage.removeItem(GEXPIRY_KEY);
      return null;
    }
    return token;
  };

  const getAdminAuthToken = () => {
    const token = localStorage.getItem(LOGIN_KEY);
    // const expiry = parseInt(localStorage.getItem(GEXPIRY_KEY) || "0", 10);

    if (!token) {
      // Expired or missing → clear storage
      localStorage.removeItem(LOGIN_KEY);
      // localStorage.removeItem(GEXPIRY_KEY);
      return null;
    }
    return token;
  };

  return (
    <AuthContext.Provider
      value={{
        storeGooleAuthToken,
        getGoogleAuthToken,
        storeAdminAuthToken,
        getAdminAuthToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const authContextValue = useContext(AuthContext);
  if (!authContextValue) {
    throw new Error("useAuth used outside of the Provider");
  }
  return authContextValue;
};
